import {
  get,
  put,
} from '@/utils/request';

const url = 'integral-update-records';

export function index({ page, size, student_id }) {
  return get({
    url,
    data: { page, size, student_id },
  });
}

// 重置积分记录的剩余积分
export function resetSurplus(offset) {
  return put({
    url: `${url}/surplus/${offset}`,
  });
}
